import Register from './register'
import Callback from './callback'
export default [
  {
    path: '/register',
    name: 'register',
    component: Register,
    children: [
      {
        path: '/register/callback',
        component: Callback
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/components/register/register-router.js